module.exports = __webpack_public_path__ + "logo_24-d5f81f67c27495891b2325d7711aab00.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_24.png
// module id = 1133
// module chunks = 0 1